import AccountVerificationModal from './AccountVerificationModal.component';
import AccountVerify from './AccountVerify.component';

export default {
	AccountVerify,
	AccountVerificationModal,
};
